import React from 'react';
import BuyerBookingCardItem from './BuyerBookingCardItem';
import NoBookingsFound from '../../bookingsOverview/NoBookingsFound';
import {buyerHeaderCells} from './data.js';

const BuyerBookingCardList = (props) => {
  const {
    bookings,
    onEnd,
    onUpdate,
    onShowPaymentModal,
    onShowCancelBookingRequestModal,
    onMakePayment,
    rootStyle
  } = props;

  return (
    bookings.length ?
      bookings.map((booking) => <BuyerBookingCardItem
        key={booking.id}
        booking={booking}
        onEnd={onEnd}
        onUpdate={onUpdate}
        onShowPaymentModal={onShowPaymentModal}
        onShowCancelModal={onShowCancelBookingRequestModal}
        onMakePayment={onMakePayment}
        headerCells={buyerHeaderCells}
        rootStyle={rootStyle}
      />)
      : <NoBookingsFound/>
  );
}

export default BuyerBookingCardList;
